<template>
  <line-chart :chartdata="chartdata" />
</template>

<script>
import LineChart from '@/components/charts/line'

export default {
  name: 'CostsMetricsGraph',
  components: {
    LineChart
  },
  props: {
    metrics: {
      type: Array,
      default: () => []
    },
    activeType: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      chartdata: null
    }
  },
  methods: {
    fillChartData () {
      if (!['contract', 'group'].includes(this.activeType)) return

      const labels = this.metrics.map(metric => metric.label)
      const dataKey = this.activeType === 'contract' ? 'accounts' : 'contracts'

      const costs = this.metrics.reduce((acc, metric, index) => {
        metric[dataKey].forEach(item => {
          if (!acc[item[dataKey.slice(0, -1)]]) {
            acc[item[dataKey.slice(0, -1)]] = new Array(12).fill(0)
          }
          acc[item[dataKey.slice(0, -1)]][index] = item.cost
        })
        return acc
      }, {})

      this.chartdata = {
        labels,
        datasets: Object.keys(costs).map(key => ({
          label: key,
          data: costs[key],
          fill: false,
          borderColor: this.getColorFromString(key),
          tension: 0.1
        }))
      }
    },

    getColorFromString (str) {
      const hash = this.hashString(str)
      const hue = hash % 360
      const saturation = 80 + (hash % 20)
      const lightness = 50 + (hash % 20)
      return `hsl(${hue}, ${saturation}%, ${lightness}%)`
    },

    hashString (str) {
      return [...str].reduce((hash, char) => {
        return (hash << 5) - hash + char.charCodeAt(0)
      }, 0)
    }
  },

  created () {
    this.fillChartData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CostsMetricsGraph.vue